import storeManager from '../../store/StoreManager';

const uploadTokenReader = {
    getTokenForQuestionId(questionId) {
        return storeManager.getState().uploadToken[questionId];
    },
};

export default uploadTokenReader;
